module.exports = __webpack_public_path__ + "static/media/popup_jobdetail.1b69a26f.png";